// GW-445 — hide price + add-to-cart for COMING-SOON products in native OE lists
// (the wishlist details page, /account/wishlist/details/…). Those pages are
// rendered by OE and list products by SKU; OE knows nothing about our coming-soon
// status, so a coming-soon part shows its R0.00 price and an Add-to-Cart button.
//
// This global widget scans the item rows, asks the API which of their SKUs are
// coming soon (one bulk call), and for each such row replaces the price with a
// "Coming Soon" badge and removes the Add-to-Cart button (the Remove button
// stays). Pure client-side; degrades to a no-op if the markup differs.

import { apiJson } from '../shared/api.js';

// Collect the wishlist item rows: a row with an item SKU and an Add-to-Cart button.
function collectRows() {
	var out = [];
	var rows = document.querySelectorAll('tr[data-line-id]');
	for (var i = 0; i < rows.length; i++) {
		var tr = rows[i];
		if (tr.getAttribute('data-pf-cs') === '1') continue; // already processed
		var skuEl = tr.querySelector('.od-item-sku');
		var cart = tr.querySelector('.ws-cart-button, [add-to-cart="true"]');
		if (!skuEl || !cart) continue;
		var sku = (skuEl.textContent || '').trim();
		if (sku) out.push({ tr: tr, sku: sku });
	}
	return out;
}

function applyComingSoon(tr) {
	tr.setAttribute('data-pf-cs', '1');
	// Price → "Coming Soon" badge.
	var priceCell = tr.querySelector('.od-item-price');
	if (priceCell) {
		priceCell.classList.remove('oh-muted');
		priceCell.innerHTML = '<span class="pf-cs-badge">Coming Soon</span>';
	}
	// Remove the Add-to-Cart button (keep the Remove button).
	var carts = tr.querySelectorAll('.ws-cart-button, [add-to-cart="true"]');
	for (var i = 0; i < carts.length; i++) carts[i].style.display = 'none';
}

var _inFlight = {};
function process() {
	var rows = collectRows();
	if (rows.length === 0) return;

	// Only ask about SKUs we haven't resolved yet this page-load.
	var toAsk = [];
	var bySku = {};
	for (var i = 0; i < rows.length; i++) {
		var u = rows[i].sku.toUpperCase();
		(bySku[u] = bySku[u] || []).push(rows[i].tr);
		if (!_inFlight[u]) { _inFlight[u] = true; toAsk.push(rows[i].sku); }
	}
	if (toAsk.length === 0) return;

	var qs = '?skus=' + encodeURIComponent(toAsk.join(','));
	apiJson('/api/parts/coming-soon' + qs, null, { comingSoon: [] })
		.then(function (res) {
			var list = (res && res.comingSoon) || [];
			var set = {};
			for (var j = 0; j < list.length; j++) set[String(list[j]).toUpperCase()] = true;
			// Re-collect (rows may have changed) and apply to matching SKUs.
			var current = collectRows();
			for (var k = 0; k < current.length; k++) {
				if (set[current[k].sku.toUpperCase()]) applyComingSoon(current[k].tr);
			}
		})
		.catch(function () { /* leave the row as-is on error */ });
}

// Coalesced sweep for late/re-rendered rows (wishlist re-renders on item removal).
var scheduled = false;
function schedule() {
	if (scheduled) return;
	scheduled = true;
	var run = function () { scheduled = false; try { process(); } catch (e) { /* ignore */ } };
	if (window.requestAnimationFrame) window.requestAnimationFrame(run); else setTimeout(run, 16);
}

export function init() {
	// Cheap page gate: only wishlist item lists carry `.ws-cart-button`.
	if (!document.querySelector('.ws-cart-button, tr[data-line-id] [add-to-cart="true"]')) return;
	try { process(); } catch (e) { /* ignore */ }
	try {
		new MutationObserver(schedule).observe(document.documentElement || document.body, { childList: true, subtree: true });
	} catch (e) { /* ignore */ }
}

export var id = 'wishlist-coming-soon';
